import * as React from "react";

const MaterialCorrectionTrackingSVG = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 -960 960 960"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      {/* Libro: borde rojo */}
      <path
        d="
          M140-720
          Q140-770 190-770
          H390
          Q450-770 480-720
          Q510-770 570-770
          H770
          Q820-770 820-720
          V-280
          Q820-230 770-230
          H570
          Q510-230 480-190
          Q450-230 390-230
          H190
          Q140-230 140-280
          Z
        "
        stroke="#E52D3D"
        strokeWidth={72}
      />

      {/* Libro: interior blanco */}
      <path
        d="
          M140-720
          Q140-770 190-770
          H390
          Q450-770 480-720
          Q510-770 570-770
          H770
          Q820-770 820-720
          V-280
          Q820-230 770-230
          H570
          Q510-230 480-190
          Q450-230 390-230
          H190
          Q140-230 140-280
          Z
        "
        stroke="#FFF"
        strokeWidth={36}
      />

      {/* División central */}
      <path
        d="M480-710V-235"
        stroke="#E52D3D"
        strokeWidth={54}
      />
      <path
        d="M480-710V-235"
        stroke="#FFF"
        strokeWidth={24}
      />

      {/* Líneas del contenido */}
      <g stroke="#E52D3D" strokeWidth={42}>
        <path d="M235-590H380" />
        <path d="M235-480H350" />
        <path d="M580-590H725" />
      </g>

      <g stroke="#FFF" strokeWidth={18}>
        <path d="M235-590H380" />
        <path d="M235-480H350" />
        <path d="M580-590H725" />
      </g>

      {/* Eslabón izquierdo */}
      <path
        d="
          M610-300
          L560-250
          Q515-205 550-170
          Q585-135 630-180
          L680-230
        "
        stroke="#E52D3D"
        strokeWidth={76}
      />
      <path
        d="
          M610-300
          L560-250
          Q515-205 550-170
          Q585-135 630-180
          L680-230
        "
        stroke="#FFF"
        strokeWidth={42}
      />

      {/* Eslabón derecho */}
      <path
        d="
          M660-350
          L710-400
          Q755-445 790-410
          Q825-375 780-330
          L730-280
        "
        stroke="#E52D3D"
        strokeWidth={76}
      />
      <path
        d="
          M660-350
          L710-400
          Q755-445 790-410
          Q825-375 780-330
          L730-280
        "
        stroke="#FFF"
        strokeWidth={42}
      />

      {/* Unión central del enlace */}
      <path
        d="M625-245L715-335"
        stroke="#E52D3D"
        strokeWidth={76}
      />
      <path
        d="M625-245L715-335"
        stroke="#FFF"
        strokeWidth={42}
      />
    </svg>
  );
};

export default MaterialCorrectionTrackingSVG;